import styled from 'styled-components';

interface ContainerProps {
  isEstado?: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin-top: ${(props) => (props.isEstado ? '0' : '1rem')};
  width: ${(props) => (props.isEstado ? '19rem' : '18rem')};
  border-radius: 5px 0px 0px 5px;
  background: var(--background-item);
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  strong {
    /* width: 10px;
    margin-left: 1rem; */
    font-size: 1.5rem;
  }
`;

export const EstadoTexto = styled.div`
  margin: 0.5rem;
  width: 90%;
  display: flex;
  align-items: center;

  div {
    margin-left: 0.7rem;
  }
`;

export const EstadoInfo = styled.div`
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  strong {
    font-size: 12px;
  }
`;

export const Porcentagem = styled.div`
  width: 60px;
  height: 100%;
  border-radius: 0px 5px 5px 0px;
  background: var(--percentage);

  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 10px;
    font-weight: 700;
    color: var(--background);
  }
`;
